import {AppliedDiscountDiscountTypeWithLiterals, Coupon} from '@wix/auto_sdk_ecom_current-cart';

export class AppliedCouponModel {
  public id: string;
  public code: string;
  public discountType: AppliedDiscountDiscountTypeWithLiterals;

  constructor(params: AppliedCouponModel) {
    this.id = params.id;
    this.code = params.code;
    this.discountType = params.discountType;
  }

  public static fromSDK(appliedCoupon: Coupon, discountType: AppliedDiscountDiscountTypeWithLiterals) {
    return new AppliedCouponModel({
      id: appliedCoupon?._id,
      code: appliedCoupon?.code,
      discountType,
    });
  }
}
